module.exports = __webpack_public_path__ + "img/image_4.b4370ac5.jpg";